import React from "react";

import Optimization from "root/icons/Optimization";

// ----------------------------------------------------------------------------------
const promotionSection = {
  type: "section",
  title: "Продвижение",
  icon: Optimization,
  children: [
    {
      title: "Эффективность кластеров",
      url: "/clusters_effectiveness",
      component: React.lazy(() => import("root/pages/clusters_effectiveness/App")),
    },
    {
      title: "Реклама в карточке",
      url: "/product-optimization",
      component: React.lazy(() => import("root/pages/product-optimization/App")),
      // noProd: true,
    },
    {
      title: "Реклама в каталоге",
      url: "/category-optimization",
      component: React.lazy(() => import("root/pages/category-optimization/App")),
      // noProd: true,
    },
    {
      title: "Рекомендации",
      url: "/top-find",
      component: React.lazy(() => import("root/pages/top-find/App")),
    },
    {
      title: "Проверка кластера",
      url: "/cluster_checkup",
      component: React.lazy(() => import("root/pages/cluster_checkup/App")),
    },
    {
      title: "Кластеризатор OLD",
      url: "/groupClusterer",
      component: React.lazy(() => import("root/pages/group_clusterer/App")),
      noProd: true,
    },
  ],
};

export default promotionSection;
